export default [
  [`Размеры`, `XS`, `S`, `M`, `L`, `XL`, `2XL`, `3XL`, `4XL`, `5XL`],
  [`Российский размер`, `44`, `46`, `48`, `50`, `52`, `54`, `56`, `58`, `60`],
  [`Рост`, `176`, `176`, `176`, `182`, `182`, `182`, `182`, `182`, `182`],
  [
    `Объем груди(a)`,
    `88`,
    `92`,
    `96`,
    `100`,
    `104`,
    `108`,
    `112`,
    `116`,
    `120`
  ],
  [`Обхват талии (b)`, `72`, `76`, `80`, `84`, `88`, `92`, `96`, `100`, `104`],
  [
    `Ширина изделия по груди (c)`,
    `42`,
    `43`,
    `45`,
    `48`,
    `50`,
    `52`,
    `56`,
    `58`,
    `60`
  ],
  [`Длина изделия (d)`, `66`, `67`, `68`, `69`, `71`, `72`, `75`, `78`, `84`]
];
